// Configuration for API and Socket.IO connections
// Simple logic: if we're on port 3000 (React dev server), use localhost:3001 for backend
// Otherwise, use the same origin (for production builds)
const isReactDevServer = window.location.port === '3000';
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// For development (localhost:3000), use the dev server
// For production or other environments, use same origin
export const SERVER_URL = (isReactDevServer && isLocalhost) 
  ? 'http://localhost:3001' 
  : window.location.origin;

export const API_BASE_URL = `${SERVER_URL}/api`; 